export const ACTION = {
    GET_SCHEME_CONTENT: 'GET_SCHEME_CONTENT',
    GET_PERFORMANCE_TAB_CONTENT:'GET_PERFORMANCE_TAB_CONTENT',
    GET_FUNDFACTS_TAB_CONTENT:'GET_FUNDFACTS_TAB_CONTENT',
    GET_FUNDFACTS_TAB_NAV_CONTENT:'GET_FUNDFACTS_TAB_NAV_CONTENT',
    GET_DOWNLOAD_TAB_CONTENT:'GET_DOWNLOAD_TAB_CONTENT',
    GET_OTHER_MANAGED_FUNDS:'GET_OTHER_MANAGED_FUNDS',
    GET_INVESTOR_VIEWED:'GET_INVESTOR_VIEWED',
    CLEAR_SCHEME_CONTENT:'CLEAR_SCHEME_CONTENT',
    GET_MIN_AMT_DETAIL:'GET_MIN_AMT_DETAIL'
};

